export default {
    DeviceDetector: require('device-detector'),

    map: null,
    infowindow: null,
    selectedLocation: $('.js-header-cities__btn'),
    allItems: $('.js-search-item[data-lng]'),
    markers: [],

    initMap() {
        if (!document.getElementById('map') || typeof google == 'undefined') return;

        const isNotMobile = !(this.DeviceDetector.parse(navigator.userAgent)
            .type === 'Mobile');

        this.map = new google.maps.Map(document.getElementById('map'), {
            zoom: 6,
            zoomControl: false,
            mapTypeControl: isNotMobile,
            streetViewControl: isNotMobile,
            clickableIcons: false,
            minZoom: 1.5,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_CENTER
            }
        });

        var zoomControlDiv = document.createElement('div');
        var zoomControl = new this.ZoomControl(zoomControlDiv, this.map);

        zoomControlDiv.index = 1;
        this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(zoomControlDiv);

        this.map.setCenter(new google.maps.LatLng(
            parseFloat(this.selectedLocation.data('lat')),
            parseFloat(this.selectedLocation.data('lng'))
        ));

        this.setMarkers();
    },

    setMarkers() {
        this.allItems = $('.js-search-item[data-lng]');
        this.infowindow = new google.maps.InfoWindow({});

        if (!this.allItems.length) {
            return this.map.setCenter(new google.maps.LatLng(
                parseFloat(this.selectedLocation.data('lat')),
                parseFloat(this.selectedLocation.data('lng'))
            ));
        }

        var bounds = new google.maps.LatLngBounds();

        $.each(this.allItems, (key, item) => {
            let lat,
                lng,
                img,
                title,
                link,
                price;
            
            lat = $(item).attr('data-lat')
            lng = $(item).attr('data-lng')
            img = $(item).attr('data-img')
            title = $(item).attr('data-title')
            link = $(item).attr('href')
            price = $(item).attr('data-price')
            price = price
                ? `<p class="category-content__cost">from $${price} per persons</p>`
                : '';

            let infoContent =
                `<a class="category-map__item" href="${link}">
                    <div class="category-content__img">
                        <img src="${img}" alt="">
                    </div>
                    <div class="category-content__wrap">
                        <h2 class="category-content__title">${title}</h2>
                        ${price}
                    </div>
                </a>`;

            if (lat == 0 || lat == null || lng == 0 || lng == null) {
                return;
            }

            let marker = new google.maps.Marker({
                position: {lat: parseFloat(lat), lng: parseFloat(lng)},
                map: this.map,
                title: title,
                zIndex: key
            });

            this.markers.push(marker);

            bounds.extend(marker.position);

            const showInMap = (e) => {
                this.infowindow.close(this.map, marker);
                this.infowindow.setContent(infoContent);
                this.infowindow.open(this.map, marker);

                $('.gm-style').removeClass('castom-card');
                $('.gm-style-iw').prev().addClass('category-map__arrow');
                $('.gm-style-iw').next().addClass('hidden');
                $('.gm-style').addClass('castom-card');
            };

            const hideInMap = (e) => {
                $('.gm-style').removeClass('castom-card');

                this.infowindow.close(this.map, marker);
                this.infowindow.setContent(null);
            };

            $(item).on('mouseenter', showInMap);
            $(item).on('mouseleave', hideInMap);

            google.maps.event.addListener(marker, 'click', showInMap);
            google.maps.event.addListener(this.map, 'click', hideInMap);
        });

        // Don't zoom in too far on only one marker
        var ne = bounds.getNorthEast();
        var sw = bounds.getSouthWest();

        if (ne && sw && ne.equals(sw)) {
           var extendPoint1 = new google.maps.LatLng(
               ne.lat() + 0.01,
               ne.lng() + 0.01
           );
           var extendPoint2 = new google.maps.LatLng(
               ne.lat() - 0.01,
               ne.lng() - 0.01
           );

           bounds.extend(extendPoint1);
           bounds.extend(extendPoint2);
        }

        this.map.fitBounds(bounds);
    },

    emptyMap() {
        $('.gm-style').removeClass('castom-card');

        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);

            this.infowindow.close(this.map, this.markers[i]);
        }

        $('.gm-style-iw')

        this.infowindow.setContent(null);

        this.infowindow.close(this.map);

        this.markers = [];
    },

    ZoomControl(controlDiv, map) {
        $(controlDiv).addClass('map-zoom-control');

        const controlWrapper = document.createElement('div');
        $(controlWrapper).addClass('map-zoom-control__wrap');
        controlDiv.appendChild(controlWrapper);

        const plus = document.createElement('i');
        plus.setAttribute('aria-hidden', 'true');
        const minus = plus.cloneNode();

        $(plus).addClass('fa fa-plus');
        $(minus).addClass('fa fa-minus');

        const zoomInButton = document.createElement('div');
        $(zoomInButton).addClass('map-zoom-control__btn');
        zoomInButton.appendChild(plus);
        controlWrapper.appendChild(zoomInButton);

        const zoomOutButton = document.createElement('div');
        $(zoomOutButton).addClass('map-zoom-control__btn');
        zoomOutButton.appendChild(minus);
        controlWrapper.appendChild(zoomOutButton);

        google.maps.event.addDomListener(zoomInButton, 'click', function() {
            map.setZoom(map.getZoom() + 1);
        });

        google.maps.event.addDomListener(zoomOutButton, 'click', function() {
            map.setZoom(map.getZoom() - 1);
        });
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/category/init-map.js